<template>
    <div>
        <h1>Authenticating...</h1>
    </div>
</template>

<script>
import store from "../store";
import router from "../router";

export default {
    created() {
        const accessToken = this.$route.hash.match(/(?:access_token)=([^&]+)/);
        const idToken = this.$route.hash.match(/(?:id_token)=([^&]+)/);
        const verification = this.$route.hash.match(/(?:state)=([^&]+)/);
        const expiresIn = this.$route.hash.match(/(?:expires_in)=(\d+)/);

        if (!accessToken  && !idToken) {
            router.push({
                name: "error",
                params: {
                    message:
                        "The authentication response did not contain a valid access_token"
                }
            });
            return;
        }
		/*
        if (!idToken) {
            router.push({
                name: "error",
                params: {
                    message:
                        "The authentication response did not contain a valid token"
                }
            });
            return;
        }
		*/
        if (!verification) {
            router.push({
                name: "error",
                params: {
                    message:
                        "The authentication response did not contain a valid verification state value"
                }
            });
            return;
        }

        if (!expiresIn) {
            router.push({
                name: "error",
                params: {
                    message:
                        "The authentication response did not contain a valid token expiry date"
                }
            });
            return;
        }

        store.dispatch("authenticate", {
            accessToken: accessToken?accessToken[1]:null,
            idToken: idToken?idToken[1]:null,
            verification: verification[1],
            expiresIn: expiresIn[1]
        });
    }
};
</script>